export default {
      id: "ic_info_orange-usage",
      viewBox: "0 0 16 16",
      url: "/" + "images/icons.3.109.2.svg#ic_info_orange-usage",
      toString: function () {
        return this.url;
      }
    }